<script>
	import PersonalDetails from "./PersonalDetails.svelte";
	import Details from "./Details.svelte";
	//import BankDetails from "../Common/BankDetails.svelte";

	import { projectSettings } from "../../config";
	import { pageNumber, model } from "../../stores";

	export let pageIndex = null;
	export let pageTitle = null;

	let disabled = true;

	$pageNumber = pageIndex;
	document.title = pageTitle;
</script>

<section>
	<h1>{`${projectSettings.classActionName} Registration`}</h1>

	<PersonalDetails {disabled}></PersonalDetails>
	<Details {disabled}></Details>
	<!-- <BankDetails {disabled}></BankDetails> -->
</section>
